module.exports = __webpack_public_path__ + "img/checkbox-active.f379a551.svg";